module.exports = __webpack_public_path__ + "static/the_lonely-af1f7dcbf520055b7b4c718d9e24b8ac.png";